/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeResponseSchema } from './availabilityRangeResponseSchema';

export const holidaySchemeResponseSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  description: z.string().nullish(),
  holidayCount: z.int().nullish(),
  id: z.int(),
  instanceId: z.string().nullish(),
  isDefault: z.boolean(),
  lastSyncedAt: z.iso.datetime().nullish(),
  locationIds: z.array(z.int()),
  memberCount: z.int().nullish(),
  name: z.string(),
  organizationId: z.string(),
  get ranges() {
    return z.array(availabilityRangeResponseSchema).nullish();
  },
  skippedSyncedResourceIds: z.array(z.int()).nullish(),
  sourceId: z.string().nullish(),
  type: z.enum(['HOLIDAY', 'WORKLOAD']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
